import { render, staticRenderFns } from "./wechartSystem.vue?vue&type=template&id=ca815042&scoped=true&"
import script from "./wechartSystem.vue?vue&type=script&lang=js&"
export * from "./wechartSystem.vue?vue&type=script&lang=js&"
import style0 from "./wechartSystem.vue?vue&type=style&index=0&id=ca815042&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca815042",
  null
  
)

export default component.exports